// extracted by mini-css-extract-plugin
export default {"fileNameInput":"FileNameChange_fileNameInput__DwUxE","fileNameChangeButtons":"FileNameChange_fileNameChangeButtons__-5H+n"};